module.exports = __webpack_public_path__ + "static/img/meecees_pictgrid27_980x868.1f628e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/meecees_pictgrid27_980x868.jpg
// module id = 8m/g
// module chunks = 0